import { render, staticRenderFns } from "./OrderedQueue.vue?vue&type=template&id=d48324ee&scoped=true"
import script from "./OrderedQueue.vue?vue&type=script&lang=ts"
export * from "./OrderedQueue.vue?vue&type=script&lang=ts"
import style0 from "./OrderedQueue.vue?vue&type=style&index=0&id=d48324ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48324ee",
  null
  
)

export default component.exports